
import styled from '@emotion/native';
import React, { FC, useEffect, useState } from 'react';
// import {
//   Row,
//   Spacer,
//   Text
// } from '@components/1-atoms';
import Text from '@components/1-atoms/Text';
import ListItem, { ListItemData } from './ListItem';

import { FlatList } from 'react-native';

import * as utils from '@lib/utils';

import DefaultCheckedIcon from '@assets/icons/checked';
import DefaultUncheckedIcon from '@assets/icons/unchecked';


const Container = styled.View``;


export type Props = {
  data: Array<any>;
  defaultValue?: any;
  CheckedIcon?: React.ComponentType;
  UncheckedIcon?: React.ComponentType;
  right?: any;
  onChange?: (value: ListItemData) => void;
  onPress?: (selected: ListItemData) => void;
};

const List: FC<Props> = ({
  onChange,
  onPress, // 2. for event association
  defaultValue,
  data,
  CheckedIcon = DefaultCheckedIcon,
  UncheckedIcon = DefaultUncheckedIcon,
  ...props
}) => {

  const [value, setValue] = useState(defaultValue);
  useEffect(() => { setValue(defaultValue); }, [defaultValue]);

  useEffect(() => {
    return onChange?.(defaultValue);
  }, [value]);

  const _onPress = (item: ListItemData) => {
    if (utils.deepEqual(value, item)) {
      setValue(null);
    } else {
      setValue(item);
    }
    onPress?.(item);
  };

  const _renderItem = ({ item, index }: { item: any, index: number }) => {

    return (
      <ListItem
        onPress={() => { _onPress(item) }}
        right={(utils.deepEqual(value, item) && <CheckedIcon />)}
        sub={<Text small color={"#808080"}>{item.description}</Text>}
        {...props}
      >
        <Text>{item.name}</Text>
      </ListItem>
    );
  };

  return (
    <Container>
      {/* <Row style={css`justify-content: center;`}>
          <Input left={<Search/>} />
        </Row>
        <Spacer h={1} /> */}

      <FlatList
        data={data}
        renderItem={_renderItem}
        keyExtractor={(item) => `${item?.id}`}
      />

    </Container>
  );
};

export default List;